import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EmployeeReportsChild from "./EmployeeReportsChild";

const EmployeeReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EmployeeReportsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EmployeeReports;
